/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationFilterBase extends models.AppSecopsFilterBase {
    getFixupPrototypeFunction() { return AppSecopsApplicationFilterBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationFilterBase>): AppSecopsApplicationFilterBase {
        let obj = Object.assign(new AppSecopsApplicationFilterBase(), model);
        AppSecopsApplicationFilterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationFilterBase>): AppSecopsApplicationFilterBase {
        if (!model) return null;
        return AppSecopsApplicationFilterBase.newInstance(<AppSecopsApplicationFilterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationFilterBase) {
        if (!obj) return;

        models.AppSecopsApplicationFilterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationFilterBase): boolean {
        if (models.AppSecopsFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationFilterBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owner of the Portfolio
     */
    owner: Array<string>;

    /**
     * ID of the portfolios to which the application belongs.
     */
    portfolio_ids: Array<string>;

    /**
     * Name of the portfolios to which the application belongs.
     */
    portfolio_names: Array<string>;

    /**
     * ID of the appsecops project to which the application belongs.
     */
    appsecops_project_ids: Array<string>;

    /**
     * Name of the appsecops project to which the application belongs.
     */
    appsecops_project_names: Array<string>;

    /**
     * Search based on name, description and owner
     */
    search: string;

    /**
     * Workload IDs to filter applications mapped to a specific workload.
     */
    workload_ids: Array<string>;

}
